import {
    IconTwitch,
    IconYoutube,
    IconDiscord,
    IconTwitter,
    IconTiktok,
    IconMerch,
    IconPatreon,
    IconBluesky
} from './icons/IconsSocials'
import '../styles/SocialCardItem.css';
import {useState, useEffect} from "react";

import { COLORS, SIZES, ANIMATION_TYPES } from '../CONSTANTS'

export function SocialCardItem ({ type, social, title, subtitle, url, screenWidth='' }) {

    const [isMobile, setIsMobile] = useState(false)

    useEffect(() => {
    const detectScreenType = () => {
        if (window.innerWidth < 600) {
            setIsMobile(true);
        } else {
            setIsMobile(false);
        }
    };

    window.addEventListener("resize", detectScreenType)
    detectScreenType()
    return () => window.removeEventListener("resize", detectScreenType);
    }, []);

    let SocialIcon = undefined
    switch (social) {
        case 'bluesky':
            SocialIcon = IconBluesky
            break
        case 'discord':
            SocialIcon = IconDiscord
            break
        case 'merch':
            SocialIcon = IconMerch
            break
        case 'patreon':
            SocialIcon = IconPatreon
            break
        case 'tiktok':
            SocialIcon = IconTiktok
            break
        case 'twitch':
            SocialIcon = IconTwitch
            break
        case 'twitter':
            SocialIcon = IconTwitter
            break
        default:
            SocialIcon = IconYoutube
            break
    }

    // Dynamic stylings for "main" & "secondary" socials
    let fontSize = type === 'main' ? SIZES.FONT_SIZE_MAIN : SIZES.FONT_SIZE_SECONDARY
    let iconSize = type === 'main' && !isMobile ? SIZES.ICON_SIZE_MAIN : SIZES.ICON_SIZE_SECONDARY
    let animationType = type === 'main' ? ANIMATION_TYPES.MAIN : ANIMATION_TYPES.SECONDARY

    if (screenWidth < 600 && iconSize === SIZES.ICON_SIZE_SECONDARY) {
        iconSize = SIZES.ICON_SIZE_SECONDARY_MOBILE
    }

    // Handle mouse-over animations
    function mouseEnter () {
        let card = document.getElementById(`social-card-${social}`)
        card.classList.add(animationType)
        card.addEventListener('animationend', () => {
            card.classList.remove(animationType)
        });
    }

    // Send user to the appropriate URL on click
    function onClick () {
        window.open(url, '__blank')
    }

    return (
        <div
            id={`social-card-${social}`}
            className={`cardItem-outer animate__animated ${type}`}
            style={{backgroundColor: `#${COLORS[social]}`}}
            onMouseEnter={mouseEnter}
            onClick={onClick}
        >
            <h2 className={`card-social-text text-${type}`} style={{fontSize: `${fontSize}px`}}>{title}</h2>
            <SocialIcon className={`card-social-icon icon-${type}`} size={iconSize}/>
            <h2 className={`card-social-text text-${type}`} style={{fontSize: `${fontSize}px`}}>{subtitle}</h2>
        </div>
    )
}